export const breakpoint = {
	lg: 1024,
}
